import AdvisorPackageBoxes from './AdvisorPackageBoxes/AdvisorPackageBoxes.svelte'
import BannersImageOnly from './BannersImageOnly/BannersImageOnly.svelte'
import BannersTeamBanner from './BannersTeamBanner/BannersTeamBanner.svelte'
import BasicsArticle01 from './BasicsArticle01/BasicsArticle01.svelte'
import BasicsAuthor from './BasicsAuthor/BasicsAuthor.svelte'
import BasicsBlogView from './BasicsBlogView/BasicsBlogView.svelte'
import BasicsBlogView01 from './BasicsBlogView01/BasicsBlogView01.svelte'
import BasicsButton from './BasicsButton/BasicsButton.svelte'
import BasicsFaq01 from './BasicsFaq01/BasicsFaq01.svelte'
import BasicsHeroText from './BasicsHeroText/BasicsHeroText.svelte'
import BasicsHeroText02 from './BasicsHeroText02/BasicsHeroText02.svelte'
import BasicsImage from './BasicsImage/BasicsImage.svelte'
import BasicsPdfViewer from './BasicsPdfViewer/BasicsPdfViewer.svelte'
import BasicsSeparator from './BasicsSeparator/BasicsSeparator.svelte'
import BasicsTextBlock from './BasicsTextBlock/BasicsTextBlock.svelte'
import BoxesAboutUsBox01 from './BoxesAboutUsBox01/BoxesAboutUsBox01.svelte'
import BoxesBox01 from './BoxesBox01/BoxesBox01.svelte'
import BoxesBox02 from './BoxesBox02/BoxesBox02.svelte'
import BoxesBox03 from './BoxesBox03/BoxesBox03.svelte'
import BoxesBox04 from './BoxesBox04/BoxesBox04.svelte'
import BoxesBox05 from './BoxesBox05/BoxesBox05.svelte'
import BoxesBoxGroup01 from './BoxesBoxGroup01/BoxesBoxGroup01.svelte'
import BoxesBoxPrimary from './BoxesBoxPrimary/BoxesBoxPrimary.svelte'
import BoxesLogoBoxGroup from './BoxesLogoBoxGroup/BoxesLogoBoxGroup.svelte'
import CarouselsReviews01 from './CarouselsReviews01/CarouselsReviews01.svelte'
import CarouselsSteps01 from './CarouselsSteps01/CarouselsSteps01.svelte'
import ContactsContactBox01 from './ContactsContactBox01/ContactsContactBox01.svelte'
import DetailsBlockBackground from './DetailsBlockBackground/DetailsBlockBackground.svelte'
import FormsGrants01 from './FormsGrants01/FormsGrants01.svelte'
import HeaderImage from './HeaderImage/HeaderImage.svelte'
import LayoutSpace from './LayoutSpace/LayoutSpace.svelte'
import MiscInvestors from './MiscInvestors/MiscInvestors.svelte'
import ProductsBrands from './ProductsBrands/ProductsBrands.svelte'
import TablesSimpleTable01 from './TablesSimpleTable01/TablesSimpleTable01.svelte'

export default {
	BoxesBoxPrimary,
	BannersTeamBanner,
	BasicsArticle01,
	BasicsFaq01,
	BasicsImage,
	BasicsPdfViewer,
	BasicsTextBlock,
	BannersImageOnly,
	BoxesBox01,
	BoxesBox02,
	BoxesBox03,
	BoxesBox04,
	BoxesBox05,
	BasicsHeroText,
	BasicsHeroText02,
	LayoutSpace,
	ProductsBrands,
	FormsGrants01,
	BasicsSeparator,
	DetailsBlockBackground,
	HeaderImage,
	TablesSimpleTable01,
	ContactsContactBox01,
	BasicsAuthor,
	BasicsBlogView,
	BoxesBoxGroup01,
	CarouselsReviews01,
	CarouselsSteps01,
	MiscInvestors,
	BoxesAboutUsBox01,
	BasicsBlogView01,
	BasicsButton,
	AdvisorPackageBoxes,
	BoxesLogoBoxGroup
}
